module.exports = {
	"header.logo.title": "Le configurateur de douche GROHE",
	"homepage.headline": "Le configurateur de douche GROHE",
	"homepage.introtext": "Répondez à quelques questions ci-dessous pour trouver le système de douche GROHE SmartControl le plus adapté à vos besoins.",
	"homepage.buttonStart": "Commencez",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"footer.privacy.text": "Vie privée",
	"footer.privacy.url": "https://www.grohe.fr/fr_fr/entreprise-grohe/protections-des-donnees.html",
	"footer.disclaimer.text": "Mentions légales",
	"footer.disclaimer.url": "https://www.grohe.fr/fr_fr/entreprise-grohe/mentions-legales.html",
	"footer.copyright": " © 2017 © GROHE S.A.R.L.",
	"configurator.button.seeResults": "Résultats",
	"question1.question": "Où souhaitez-vous prendre votre douche?",
	"question1.option1.text": "Douche",
	"question1.option2.text": "Bain",
	"question2.question": "Quel type d'installation préférez-vous? Apparent ou Encastré?",
	"question2.option1.text": "Installation apparente de la douche et du thermostatique",
	"question2.option2.text": "Mitigeur thermostatique installé apparent, mais avec douche encastrée",
	"question2.option3.text": "Installation encastrée",
	"question3.question": "Où souhaitez-vous prendre votre douche?",
	"question3.option1.text": "Avec le thermostatique  SmartControl",
	"question3.option2.text": "Avec un mitigeur thermostatique",
	"question3.option3.text": "Mitigeur monocommande douche",
	"question3.option4.text": "Inverseur manuel (sur un système de douche déjà existant)",
	"question4.question": "Que souhaitez-vous contrôler avec votre douche?",
	"question4.option1.text": "Uniquement la douchette à main",
	"question4.option2.text": "Une large douche de tête (150-250mm) et une douchette à main",
	"question4.option3.text": "Une douche de tête extra large (250-400mm) et une douchette à main",
	"question4.option4.text": "Une large douche de tête (150-250mm), une douchette à main et vidage baignoire",
	"question4.option5.text": "Une douche de tête extra large (250-400mm), une douchette à main et vidage baignoire",
	"question5.question": "Quel design préférez-vous?",
	"question5.option1.text": "Carré",
	"question5.option2.text": "Rond",
	"question6.question": "Combien de sortie d'eau avez-vous besoin?",
	"question6.option1.text": "Trois sorties : Douche de tête 2 jets et douchette à main",
	"question6.option2.text": "Trois sorties : Douche de tête 2 jets et douchette à main",
	"question6.option3.text": "Trois sorties : Douche de tête, douchette à main et  bec de remplissage",
	"question6.option4.text": "Trois sorties : Douche de tête, douchette latérale et douchette à main",
	"question6.option5.text": "Deux sorties : Douche de tête et douchette à main",
	"question6.option6.text": "Deux sorties : Douchette à main et bec de remplissage",
	"question6.option7.text": "Une sortie : seulement une douchette à main",
	"question6.option8.text": "Une sortie : Bec bain",
	"question7.question": "Choisissez votre couleur?",
	"question7.option1.text": "Chromée",
	"question7.option2.text": "Blanc/Chromée",
	"question7.option3.text": "Blanc/Chromée",
	"question8.question": "Souhaitez-vous  une façade  avec un support de douchette intégré?",
	"question8.option1.text": "Oui, avec un support de douchette intégré",
	"question8.option2.text": "Non, j'achèterai un support de douchette séparement",
	"question9.question": "Souhaitez-vous un ensemble de douche avec une barre pour la douchette à main ou simplement un support mural?",
	"question9.option1.text": "Ensemble de douche",
	"question9.option2.text": "Support de douche mural",
	"question10.question": "Préférez-vous une douche de tête avec un bras horizontal ou vertical",
	"question10.option1.text": "Douche de tête avec un bras horizontal",
	"question10.option2.text": "Douche de tête avec un bras vertical",
	"results.title": "{productGroupsCount, plural, \none {Votre résultat} \nother {Vos résultats}\n}",
	"results.bundle.title": "Pour une bonne installation, vous aurez également  besoin de:",
	"results.newConfiguration.buttonText": "Commencez une nouvelle configuration",
	"results.product.button.productInformation": "Des informations relatives au produit",
	"results.product.button.dealerLocator": "Trouvez une salle d'exposition",
	"results.product.button.buyNow": "Achetez en ligne",
	"results.product.information": "Des informations relatives au produit",
	"results.product.dealer": "Trouvez une salle d'exposition",
	"results.proposal.title": "Proposition {number}",
	"results.proposal.title.single": "Proposition",
	"results.newConfiguration.title": "Voulez-vous configurer un nouveau système de douche ?",
	"results.product.number": "Référence #{number}",
	"results.product.button.downloadPDF": "Télécharger la proposition (PDF)",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Achetez en ligne",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"404.title": "Erreur page 404",
	"404.link.goBack": "Retour à la page d’accueil"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.fr_fr.json
// module id = 757
// module chunks = 0